<div class="SLV2-LHS-mob-burger-menu">
    <img src="selflearnv2-ui/assets/img/self-learn-v2/mobile-burger-menu.svg" />
</div>
<div class="SLV2-LHS-section">


    <div class="SLV2-leftsidebarprofile">
        <div class="SLV2-user-prfimg">
            <img src="selflearnv2-ui/assets/img/avatar-3.jpg" alt="" />
        </div>
        <div class="SLV2-desccont">
            <h3 class="SLV2-desc-tittle">Firstname Lastname</h3>
            <p class="SLV2-desc-subtitle">Grade 10, Examname</p>
            <button class="SLV2-profile-btn">
                <img src="selflearnv2-ui/assets/img/pagination-next-arrow-dark.svg" />
            </button>
        </div>
    </div>


    <ul class="SLV2-LHS-menu-list">
        <li class="active">
            <span class="menu-icn">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/menu/home-icon.svg" />
                <img class="active-icon" src="selflearnv2-ui/assets/img/self-learn-v2/menu/home-active-icon.svg" />
            </span>
            <span>Home</span>
        </li>
        <li>
            <span class="menu-icn">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/menu/video-icon.svg" />
                <img class="active-icon" src="selflearnv2-ui/assets/img/self-learn-v2/menu/video-active-icon.svg" />
            </span>
            <span>Live Classes</span>
        </li>
        <li>
            <span class="menu-icn">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/menu/learn-icon.svg" />
                <img class="active-icon" src="selflearnv2-ui/assets/img/self-learn-v2/menu/learn-active-icon.svg" />
            </span>
            <span>Learn</span>
        </li>
        <li>
            <span class="menu-icn">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/menu/test-icon.svg" />
                <img class="active-icon" src="selflearnv2-ui/assets/img/self-learn-v2/menu/test-active-icon.svg" />
            </span>
            <span>Tests</span>
        </li>
        <li class="border">
            <span class="menu-icn">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/menu/account-icon.svg" />
                <img class="active-icon" src="selflearnv2-ui/assets/img/self-learn-v2/menu/account-active-icon.svg" />
            </span>
            <span>Account</span>
        </li>
        <li>
            <span class="menu-icn">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/menu/bookmark-icon.svg" />
                <img class="active-icon" src="selflearnv2-ui/assets/img/self-learn-v2/menu/bookmark-active-icon.svg" />
            </span>
            <span>My Bookmarks</span>
        </li>
        <li>
            <span class="menu-icn">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/menu/subscription-icon.svg" />
                <img class="active-icon" src="selflearnv2-ui/assets/img/self-learn-v2/menu/subscription-active-icon.svg" />
            </span>
            <span>Subscription</span>
        </li>
        <li class="border">
            <span class="menu-icn">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/menu/contact-icon.svg" />
                <img class="active-icon" src="selflearnv2-ui/assets/img/self-learn-v2/menu/contact-active-icon.svg" />
            </span>
            <span>Contact Us</span>
        </li>
    </ul>
</div>
<div class="m-overlay"></div>
